import moment from "moment-timezone"

const helpers = {
  formatDate: (date) => moment(date).format("MMM Do YYYY"),
  formatDateTime: (date) => moment(date).format("MMM Do YYYY h:mma"),
  formatDateTimeWithZone: (date) => {
    const m = moment(date);
    const tz = moment.tz.guess(); // Get browser's timezone
    return m.tz(tz).format("MMM Do YYYY h:mma z");
  },
  eventTimestamp: (date) => moment(date).format("MM-DD-YY@H:mm:ss"),
  eventTimestampWithZone: (date) => {
    const m = moment(date);
    const tz = moment.tz.guess(); // Get browser's timezone
    return m.tz(tz).format("MM-DD-YY@H:mm:ss z");
  },
}
export const { formatDate, formatDateTime, formatDateTimeWithZone, eventTimestamp, eventTimestampWithZone } = helpers;
export default helpers
